<template>
	<v-row>
		<v-col>
			<geofence
				v-if="selectedService && selectedPlace"
				id-map="1"
				:height-map="$vuetify.breakpoint.lgAndUp ? '140px' : '250px'"
				:place="selectedPlace"
				:id-place="selectedPlace.value"
				:toggle-config-marks-per-day="toggleConfigMarksPerDay"
			/>
			<v-btn
				v-if="Boolean(selectedPlace)"
				text
				x-small
				@click="toggleConfigMarksPerDay = !toggleConfigMarksPerDay"
			>
				{{
					toggleConfigMarksPerDay
						? `Ver ultimas ubicaciones del mes (${changeFormat(rangeDate.end)})`
						: `Ver ubicaciones de hoy`
				}}
			</v-btn>
		</v-col>
	</v-row>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';

export default {
	components: {
		Geofence: () => import('@/components/place/Geofence'),
	},
	data() {
		return { toggleConfigMarksPerDay: false };
	},
	computed: {
		...mapGetters({
			selectedService: 'Lodging/selectedService',
			selectedPlace: 'Lodging/selectedPlace',
			rangeDate: 'Lodging/rangeDate',
		}),
	},
	methods: {
		changeFormat(date) {
			return moment(date).format('MMMM');
		},
	},
};
</script>
